import checkoutService from "./payments/checkout";
import upgradeService from "./payments/upgrade";
import paymentLinkService from "./payments/payment-link";
import cancelPlanEvents from "./payments/cancelPlanEvents";
import jusprocessoSubscription from "./jusprocessoSubscription";
import loggedCheckout from './payments/logged-checkout';

export const tracking = {
  checkout: checkoutService,
  loggedCheckout: loggedCheckout,
  upgrade: upgradeService,
  paymentLink: paymentLinkService,
  cancel: cancelPlanEvents,
  jusprocessos: jusprocessoSubscription,
}
